import { ThemePalette } from '@angular/material/core';
import { ProgressBarMode } from '@angular/material/progress-bar';
import { Subscription } from 'rxjs';
import { CommonUtilities } from '../common-utilities';
import { FileUploadInfoErrorEnum } from './shared.model';

export class FileUploadInfo {
    private readonly _name: string;
    private readonly size: number;
    private readonly _extension: string;
    private _uploadProgress = 0;
    private _subscription = Subscription.EMPTY;
    private _uploading = false;
    private _success = false;
    private readonly _progressBarColor: ThemePalette = 'primary';
    private _progressBarMode: ProgressBarMode = 'determinate';
    error: { [errorType in FileUploadInfoErrorEnum]: string } = {
        onUpload: '',
        fileSize: '',
        fileType: '',
        fileAmount: ''
    };

    constructor(data: { name: string; size: number; extension: string }) {
        this._name = data.name;
        this.size = data.size;
        this._extension = data.extension;
    }

    get name() {
        return this._name;
    }

    get extension() {
        return this._extension;
    }

    get isUploading() {
        return this._uploading;
    }

    get isSuccess() {
        return this._success;
    }

    get uploadProgress() {
        return this._uploadProgress;
    }

    get progressBarMode() {
        return this._progressBarMode;
    }

    get progressBarColor() {
        return this._progressBarColor;
    }

    updateProgress = (uploaded: number) => {
        this._uploadProgress = Math.round(100 * (uploaded / this.size));
    };

    markAsUploading = () => {
        this._uploading = true;
    };

    markAsSuccess = () => {
        this._uploading = false;
        this._progressBarMode = 'determinate';
        this._success = true;
    };

    markAsInProgress = () => {
        this._progressBarMode = 'indeterminate';
    };

    cancelUpload = () => {
        this._subscription.unsubscribe();
        this._uploadProgress = 0;
        this._uploading = false;
    };

    updateSubscription = (newSubscription: Subscription) => {
        this._subscription = newSubscription;
    };

    static generateFileUploadInfo(file: File): FileUploadInfo {
        return new FileUploadInfo({
            name: file.name,
            size: file.size,
            extension: CommonUtilities.getFileExtension(file.name) ?? 'Unknown'
        });
    }
}
